import { fetchFile } from '@ffmpeg/util';
export function capitalizeFirstLetter(str: string) {
  return str.charAt(0).toUpperCase() + str.slice(1);
}

export function convertToMinutesAndSeconds(totalSeconds: number) {
  const minutes = Math.floor(totalSeconds / 60);
  const seconds = totalSeconds % 60;
  const formatMinutes = minutes < 10 ? `0${minutes}` : minutes;
  const formatSeconds = seconds < 10 ? `0${seconds}` : seconds;

  return `${formatMinutes}:${formatSeconds}`;
}

export const calculVideoChunk = (duration: number, numOfChenck: number) => {
  const result = Math.round(duration / numOfChenck);

  return result;
};

export const calculationProgressVideo = (
  currentSec: number,
  durationVideo: number,
) => {
  const progress = (currentSec / durationVideo) * 100;
  return progress;
};

export const blobToFile = (theBlob: Blob, fileName: string) => {
  return new File([theBlob], fileName, {
    lastModified: new Date().getTime(),
    type: theBlob.type,
  });
};

export const randomArray = (array: any[]) => {
  if (array.length <= 5) {
    return array;
  }

  const uniqueIndices = new Set<number>();
  const randomNumbers = [];

  while (uniqueIndices.size < 5) {
    const randomIndex = Math.floor(Math.random() * array.length);

    if (!uniqueIndices.has(randomIndex)) {
      uniqueIndices.add(randomIndex);
      randomNumbers.push(array[randomIndex]);
    }
  }

  return randomNumbers;
};
export const generateBlobUrl = (recordChunks: string[]) => {
  const blob = new Blob(recordChunks, {
    type: 'video/webm',
  });

  const blobUrl = URL.createObjectURL(blob);
  return blobUrl;
};

export const generateBlobUrlFInal = (blob: Blob) => {
  const blobUrl = URL.createObjectURL(blob);
  return blobUrl;
};

export const transcode = async (
  inputVideo: Blob | undefined,
  ffmpegRef: any,
) => {
  const ffmpeg = ffmpegRef.current;
  const fetchFileOutput = await fetchFile(inputVideo);
  ffmpeg?.writeFile('input.webm', fetchFileOutput);

  return 'hello'; // execute by node-media-server config 1

  // execute by node-media-server config 2
  // await ffmpeg?.exec(['-re', '-i', 'input.webm', '-c:v', 'libx264', '-preset', 'veryfast', '-tune', 'zerolatency', '-c:a', 'aac', '-ar', '44100', '-f', 'flv', 'rtmp://localhost:1935/live/ttt']);

  // execute by stack-over-flow config 1
  // await ffmpeg?.exec(['-re', '-i', 'input.webm', '-c:v', 'h264', '-c:a', 'aac', '-f', 'flv', "rtmp://localhost:1935/live/ttt"]);

  // execute by stack-over-flow config 2
  // await ffmpeg?.exec(['-i', 'input.webm', '-c:v', 'libx264', '-flags:v', '+global_header', '-c:a', 'aac', '-ac', '2', '-f', 'flv', "rtmp://localhost:1935/live/ttt"]);

  // execute by stack-over-flow config 3
  // await ffmpeg?.exec(['-i', 'input.webm', '-acodec', 'aac', '-ac', '2', '-strict', 'experimental', '-ab', '160k', '-vcodec', 'libx264', '-preset', 'slow', '-profile:v', 'baseline', '-level', '30', '-maxrate', '10000000', '-bufsize', '10000000', '-b', '1000k', '-f', 'flv', 'rtmp://localhost:1935/live/ttt']);
};

export const recordChunkToBlob = (recordChunks: any) => {
  const recordedBlob = new Blob(recordChunks, { type: 'video/mp4' });
  return recordedBlob;
};

export function dataURItoBlob(dataURI: string) {
  const byteString = atob(dataURI.split(',')[1]);

  const mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0];

  const ab = new ArrayBuffer(byteString.length);
  const ia = new Uint8Array(ab);
  for (let i = 0; i < byteString.length; i++) {
    ia[i] = byteString.charCodeAt(i);
  }

  const blob = new Blob([ab], { type: mimeString });
  return blob;
}
export const candidateId =
  localStorage.getItem('candidate_id') &&
  Number(localStorage.getItem('candidate_id'));

export function generateFiveRandomNumbers(number: number) {
  const numbers = new Set();
  while (numbers.size < 5) {
    const randomNumber = Math.floor(Math.random() * number);
    numbers.add(randomNumber);
  }
  return Array.from(numbers);
}
